<div class="context-view">
  <dx-popup
    [title]="'Auftrag Suchen' | translate"
    [showTitle]="true"
    [width]="'90%'"
    [height]="'90%'"
    [dragEnabled]="true"
    [hideOnOutsideClick]="false"
    [position]="{ of: windowRef, my: 'center', at: 'center' }"
    [shading]="false"
    [visible]="showSearchAssignmentDialog()"
    [showCloseButton]="true"
    (onHiding)="onSearchAssignmentClose()"
    contentTemplate="searchAssignmentDialog">
    <dxo-position boundaryOffset="0 0" at="top" [of]="'#left-col'" collision="fit"> </dxo-position>
    <div
      *dxTemplate="let data of 'searchAssignmentDialog'"
      id="searchAssignmentDialog"
      class="assignment-list-data-grid">
      <app-assignment-list-data-grid></app-assignment-list-data-grid>
    </div>
  </dx-popup>

  <div class="context-header">
    <div class="context-title">{{ 'ASSIGNMENT.LIST.TITLE' | translate }}</div>
    <div class="context-action-list">
      <dx-button
        [text]="'BUTTONS.SEARCH_ASSIGNMENT' | translate"
        [icon]="'search'"
        (onClick)="onSearchAssignmentClick()">
      </dx-button>
    </div>
  </div>
  <dx-data-grid
    id="assignment-grid"
    [dataSource]="assignments()"
    [showRowLines]="true"
    [showColumnLines]="false"
    [showBorders]="true"
    [keyExpr]="['AssignmentNo', 'Type']"
    [allowColumnReordering]="false"
    [allowColumnResizing]="false"
    [noDataText]="''"
    (onRowDblClick)="loadAssignment($event)"
    (onRowPrepared)="onRowPrepared($event)"
    (onRowExpanded)="loadAssignmentSubtableData($event)"
    (onContentReady)="calculateStats()"
    (onSelectionChanged)="updateSelectionOrder($event)">
    <dxo-row-dragging
      [group]="'assignments'"
      [showDragIcons]="false"
      [onDragStart]="onDragStart"
      [onDragEnd]="onDragEnd">
    </dxo-row-dragging>

    <dxo-paging [pageSize]="0"> </dxo-paging>
    <dxo-scrolling
      mode="infinite"
      [useNative]="false"
      [scrollByContent]="true"
      [scrollByThumb]="true"
      showScrollbar="onHover">
    </dxo-scrolling>
    <dxo-search-panel [visible]="true" [highlightCaseSensitive]="false" (textChange)="calculateStats()">
    </dxo-search-panel>
    <dxo-selection mode="multiple" showCheckBoxesMode="none" selectAllMode="page"></dxo-selection>
    <dxo-master-detail [enabled]="true" [autoExpandAll]="false" [template]="'detail'"> </dxo-master-detail>

    <!-- TOOLBAR -->
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <dx-date-range-box [(value)]="dateRange" (onClosed)="getAssignments()" width="240px" [labelMode]="'hidden'">
          </dx-date-range-box>
        </div>
      </dxi-item>

      <dxi-item name="searchPanel" location="before"></dxi-item>

      <dxi-item name="states" location="before">
        <dx-drop-down-box
          width="200px"
          [(value)]="selectedStates"
          [dataSource]="states"
          valueExpr="id"
          displayExpr="text"
          (onValueChanged)="onDropDownBoxValueChanged()">
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              #stateTree
              [dataSource]="states"
              dataStructure="plain"
              valueExpr="id"
              displayExpr="text"
              selectionMode="multiple"
              [selectByClick]="true"
              showCheckBoxesMode="normal"
              (onContentReady)="onTreeViewReady($event)"
              (onItemSelectionChanged)="onTreeViewSelectionChanged($event)">
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </dxi-item>

      <dxi-item name="infoFilter" location="before">
        <dx-drop-down-box
          width="220px"
          [(value)]="selectedInfoFilters"
          [dataSource]="infoFilters"
          valueExpr="id"
          displayExpr="text"
          (onValueChanged)="onInfoFilterValueChanged()">
          <div *dxTemplate="let data of 'content'">
            <dx-tree-view
              #infoTree
              [dataSource]="infoFilters"
              dataStructure="plain"
              valueExpr="id"
              displayExpr="text"
              selectionMode="multiple"
              [selectByClick]="true"
              showCheckBoxesMode="normal"
              (onContentReady)="onInfoTreeViewReady($event)"
              (onItemSelectionChanged)="onInfoTreeViewSelectionChanged($event)">
              <div *dxTemplate="let item of 'itemTemplate'">
                <div class="info-filter-item">
                  <!-- todo add icon here -->
                  <span class="info-filter-text">{{ item.text }}</span>
                </div>
              </div>
            </dx-tree-view>
          </div>
        </dx-drop-down-box>
      </dxi-item>

      <dxi-item name="refresh" location="before">
        <dx-button [icon]="'refresh'" (onClick)="getAssignments()"> </dx-button>
      </dxi-item>

      <dxi-item name="addToProjectButton" location="before">
        <dx-button
          [hint]="'BUTTONS.ADD' | translate"
          [icon]="'add'"
          [disabled]="isPlanningInProgress()"
          (onClick)="onAddToPlanningClick()">
        </dx-button>
      </dxi-item>

      <dxi-item location="before">
        <div *dxTemplate>
          <div class="assignment-stats">
            <div class="row">
              <app-icon class="col-1" [kind]="'AssignmentDelivery'"></app-icon>
              <div class="stat-part col-5">{{ stats.totalDeliveryVolume | number: '1.1-1' }} m³</div>
              <div class="stat-part col-5">{{ stats.totalDeliveryWeight | number: '1.1-1' }} t</div>
            </div>

            <div class="row">
              <app-icon class="col-1" [kind]="'AssignmentPickup'"></app-icon>
              <div class="stat-part col-5">{{ stats.totalPickupVolume | number: '1.1-1' }} m³</div>
              <div class="stat-part col-5">{{ stats.totalPickupWeight | number: '1.1-1' }} t</div>
            </div>
          </div>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <!-- MASTER -->
    <dxi-column
      dataField="Type"
      [width]="60"
      [caption]="'ASSIGNMENT.TYPE' | translate"
      alignment="center"
      cellTemplate="cellTemplate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>
    <div *dxTemplate="let data of 'cellTemplate'">
      <app-icon [kind]="data.text"></app-icon>
    </div>

    <dxi-column
      dataField="AssignmentNo"
      [width]="80"
      [caption]="'ASSIGNMENT.ASSIGNMENTNO' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""
      [calculateCellValue]="utilService.asString"></dxi-column>

    <dxi-column
      dataField="Statustext"
      [width]="60"
      [caption]="'ASSIGNMENT.STATUSTEXT' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""
      cellTemplate="cellTemplateStatustext">
    </dxi-column>
    <div *dxTemplate="let data of 'cellTemplateStatustext'" class="statustext-cell">
      {{ data.value }}
      @if (canBeHidden(data.data)) {
        <dx-button
          [icon]="data.data.FilterState === 1 ? 'eyeopen' : 'eyeclose'"
          stylingMode="text"
          [hint]="(data.data.FilterState === 1 ? 'BUTTONS.SHOW' : 'BUTTONS.HIDE') | translate"
          [disabled]="visibilityBusy.isBusy(visibilityKey(data.data))"
          (onClick)="onChangeVisibilityOfAssignment(data.data)"></dx-button>
      }
    </div>

    <dxi-column
      dataField="MIAuftrag"
      [width]="60"
      [caption]="'ASSIGNMENT.INFO' | translate"
      alignment="left"
      cellTemplate="cellTemplateMI"
      cssClass="badge-cell"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
    </dxi-column>
    <div *dxTemplate="let data of 'cellTemplateMI'" class="mi">
      <app-assignment-info-badges [assignment]="data.data" />
    </div>

    <dxi-column
      dataField="EventDate"
      [width]="90"
      [caption]="'ASSIGNMENT.ACTIONDATE' | translate"
      format="EE dd.MM.yy"
      dataType="date"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""
      [calculateCellValue]="calculateDisplayEventDate"
      cssClass="bold">
    </dxi-column>

    <dxi-column
      dataField="EventTime"
      [width]="80"
      [caption]="'ASSIGNMENT.ACTIONTIME' | translate"
      dataType="time"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""
      cssClass="bold"
      cellTemplate="eventTimeTemplate"></dxi-column>
    <div *dxTemplate="let data of 'eventTimeTemplate'">
      @if (data.data.ShowEventTime) {
        {{ data.value }}
      }
    </div>

    <dxi-column
      [width]="40"
      dataField="T1"
      [caption]="'ASSIGNMENT.T1' | translate"
      alignment="center"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <dxi-column
      [width]="40"
      dataField="T2"
      [caption]="'ASSIGNMENT.T2' | translate"
      alignment="center"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <dxi-column
      dataField="DispoDateFrom"
      [width]="80"
      [caption]="'ASSIGNMENT.DISPOVON' | translate"
      format="dd.MM.yy"
      dataType="date"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
    </dxi-column>

    <dxi-column
      dataField="DispoDateTo"
      [width]="80"
      [caption]="'ASSIGNMENT.DISPOBIS' | translate"
      format="dd.MM.yy"
      dataType="date"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
    </dxi-column>

    <dxi-column
      dataField="EventAddress"
      [minWidth]="120"
      [caption]="'ASSIGNMENT.EVENTADDRESS' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
    </dxi-column>

    <dxi-column
      dataField="EventStreet"
      [minWidth]="80"
      [caption]="'ASSIGNMENT.EVENTSTREET' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <dxi-column
      dataField="EventCountry"
      [width]="40"
      [caption]="'ASSIGNMENT.EVENTCOUNTRY' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <dxi-column
      dataField="EventZipCode"
      [width]="60"
      [caption]="'ASSIGNMENT.EVENTZIPCODE' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <dxi-column
      dataField="EventCity"
      [minWidth]="80"
      [caption]="'ASSIGNMENT.EVENTCITY' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <dxi-column
      dataField="EffectiveVolume"
      [width]="65"
      [caption]="'ASSIGNMENT.VOLUME' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
      <dxo-format type="fixedPoint" [precision]="1"> </dxo-format>
    </dxi-column>

    <dxi-column
      dataField="EffectiveWeight"
      [width]="65"
      [caption]="'ASSIGNMENT.WEIGHT' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
      <dxo-format type="fixedPoint" [precision]="1"> </dxo-format>
    </dxi-column>

    <dxi-column
      dataField="RemainingDispoVol"
      [width]="65"
      [caption]="'ASSIGNMENT.DISPOVOLUME' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
      <dxo-format type="fixedPoint" [precision]="1"> </dxo-format>
    </dxi-column>

    <dxi-column
      dataField="RemainingDispoWeight"
      [width]="65"
      [caption]="'ASSIGNMENT.DISPOWEIGHT' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]="">
      <dxo-format type="fixedPoint" [precision]="1"> </dxo-format
    ></dxi-column>

    <dxi-column
      dataField="Sachbearbeiter"
      [minWidth]="80"
      [caption]="'ASSIGNMENT.SACHBEARBEITER' | translate"
      [allowSorting]="false"
      [calculateSortValue]=""
      [sortingMethod]=""></dxi-column>

    <!-- DETAIL -->
    <div *dxTemplate="let item of 'detail'">
      @if (!item.data.subtableData) {
        <dx-load-indicator class="large-indicator"></dx-load-indicator>
      } @else {
        <div class="row inner-detail-table">
          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'SHARED.GENERAL' | translate }}</div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.STATUS' | translate }}:</div>
                <div class="value-static">{{ item.data.subtableData.Status }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.TRANSPORTSTATUS' | translate }}:</div>
                <div class="value-static">{{ item.data.subtableData.TransportStatus }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.ADR_POINTS' | translate }}:</div>
                <div class="static">{{ item.data.AdrPoints }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.PRODNAME' | translate }}:</div>
                <div class="value-static">{{ item.data.subtableData.ProdName }}</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.AKTIONSTEXT' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.AktionsText }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.KONTAKT' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.Kontakt }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.TRAPO_PROJECTS_ASSIGNED_TO' | translate }}:</div>
                <div class="static">{{ item.data.TrapoProjectsAssignedTo }}</div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'SHARED.WEIGHT_VOLUME' | translate }}</div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.AUSGGEWICHT_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.AusgGewicht | number: '1.2-2' }} t</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.AUSGABEVOLUMEN_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.AusgabeVolumen | number: '1.2-2' }} m³</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.DISPOGEWICHT_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.DispoGewicht | number: '1.2-2' }} t</div>
              </div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.DISPOVOLUMEN_LONG' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.DispoVolumen | number: '1.2-2' }} m³</div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="dx-field">
              <div class="header">{{ 'SHARED.ETC' | translate }}</div>
              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.MIETKAUF' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.MieteKauf }}</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.ENTFERNUNGKM' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.EntfernungKm ?? 0 }} km</div>
              </div>

              <div class="field-set">
                <div class="label">{{ 'ASSIGNMENT.SUBTABLE.MEMO' | translate }}:</div>
                <div class="static">{{ item.data.subtableData.Memo }}</div>
              </div>

              @if (item.data.Type === AssignmentType.AssignmentDelivery) {
                <div class="field-set">
                  <div class="label">{{ 'ASSIGNMENT.SUBTABLE.MIAUFTRAG' | translate }}:</div>
                  <div class="static">
                    {{ 'ASSIGNMENT.SUBTABLE.MIAUFTRAGSTATUS.' + item.data.subtableData.MIAuftrag | translate }}
                  </div>
                </div>
              }

              @if (item.data.subtableData.Type === AssignmentType.AssignmentPickup) {
                <div class="field-set">
                  <div class="label">{{ 'ASSIGNMENT.SUBTABLE.NUMMIPROBSOLUTIONS' | translate }}:</div>
                  <div class="static">{{ item.data.subtableData.NumMIProbSolutions }}</div>
                </div>
              }
            </div>
          </div>
        </div>

        @if (item.data.subtableData.PlStations && item.data.subtableData.PlStations.length > 0) {
          <div class="pl-stations-section">
            <div class="header">{{ 'ASSIGNMENT.SUBTABLE.PL_STATIONS_ASSIGNED' | translate }}</div>
            <div class="pl-stations-grid-wrapper">
              <app-assignment-list-data-grid [stations]="item.data.subtableData.PlStations" [stationsMain]="item.data">
              </app-assignment-list-data-grid>
            </div>
          </div>
        }
      }
    </div>
  </dx-data-grid>
  <app-loader [hide]="!isLoading()"></app-loader>
</div>
